module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showReport) ? _c('div', {
    staticClass: "report"
  }, [_c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("Da clic en alguna de las siguientes opciones para visualizar el "), _c('u', [_vm._v("reporte de auditoría")]), _vm._v(" al inmueble "), _c('strong', [_vm._v(_vm._s(_vm.audit.inmueble))])]), _vm._v(" "), _c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": _vm.downloadReport
    }
  }, [_vm._v("Descargar Reporte")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": _vm.showReportOnScreen
    }
  }, [_vm._v("Visualizar en Página")])]), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportLoaded),
      expression: "reportLoaded"
    }],
    attrs: {
      "id": "iframeid",
      "src": _vm.reportSrc,
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": _vm.showReportOnScreenEnd
    }
  })], 1) : _c('div', {
    staticClass: "incidences"
  }, [_c('header', [_c('div', {
    staticClass: "card-cover mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__media",
    style: ({
      background: 'url(' + _vm.audit.cover + ') center / cover'
    })
  }), _vm._v(" "), _c('div', {
    class: ['mdl-card__title', _vm.audit.promedio ? (_vm.audit.promedio >= _vm.audit.aceptable ? 'bg-green' : (_vm.audit.promedio > _vm.audit.inaceptable ? 'bg-yellow' : 'bg-red')) : 'bg-grey']
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.inmueble))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.audit.empresa))])])]), _vm._v(" "), _c('div', {
    class: ['mdl-card__title', _vm.audit.promedio ? (_vm.audit.promedio >= _vm.audit.aceptable ? 'bg-green' : (_vm.audit.promedio > _vm.audit.inaceptable ? 'bg-yellow' : 'bg-red')) : 'bg-grey']
  }, [_c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.incidencias))]), _vm._v(" "), _c('small', [_vm._v("Incidencias")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.promedio ? _vm.audit.promedio : 'N / A'))]), _vm._v(" "), _c('small', [_vm._v("Puntos")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('small', [_vm._v(_vm._s(_vm.audit.statusNombre.toUpperCase()))])])]), _vm._v(" "), _vm._l((_vm.audit.mantenimiento), function(responsable) {
    return _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + responsable.avatar + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-grow-2"
    }, [_c('strong', [_vm._v(_vm._s(responsable.nombre))]), _vm._v(" "), _c('span', [_vm._v("Responsable de Mantenimiento")])]), _vm._v(" "), _c('div')])
  })], 2)]), _vm._v(" "), _c('main', _vm._l((_vm.incidencias), function(incidencia, i) {
    return _c('div', {
      staticClass: "card-main mdl-card mdl-shadow--2dp"
    }, [_c('div', {
      staticClass: "mdl-card__title"
    }, [_c('h2', {
      staticClass: "mdl-card__title-text"
    }, [_c('strong', [_vm._v(_vm._s(incidencia.area))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(incidencia.rubro))])]), _vm._v(" "), _c('div', {
      staticClass: "chips mdl-card__helper"
    }, [_c('small', [_vm._v(_vm._s(incidencia.especificacion.toUpperCase()))]), _vm._v(" "), _c('button', {
      class: ['current-chip', 'mdl-chip', 'mdl-color--' + incidencia.color],
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.openChips
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mdl-chip__buttons",
      attrs: {
        "data-i": i
      }
    }, _vm._l((incidencia.ponderaciones), function(ponderacion, j) {
      return _c('button', {
        key: ponderacion.id,
        class: ['mdl-chip', 'mdl-color--' + ponderacion.color],
        attrs: {
          "type": "button",
          "data-id": ponderacion.id,
          "data-color": ponderacion.color,
          "data-value": ponderacion.valor
        },
        on: {
          "click": _vm.chipSelected
        }
      })
    }))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (incidencia.color.match(/red|yellow/)),
        expression: "incidencia.color.match(/red|yellow/)"
      }],
      staticClass: "incidence mdl-grid"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (incidencia.update.imagenes.length === 0),
        expression: "incidencia.update.imagenes.length === 0"
      }],
      staticClass: "mdl-cell mdl-cell--12-col"
    }, [_vm._m(0, true)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (incidencia.update.imagenes.length > 0),
        expression: "incidencia.update.imagenes.length > 0"
      }],
      staticClass: "photos mdl-cell mdl-cell--12-col"
    }, _vm._l((incidencia.update.imagenes), function(imagen, k) {
      return _c('div', {
        key: k,
        staticClass: "mdl-card mdl-shadow--2dp",
        style: ({
          background: 'url(' + imagen + ') center / cover'
        })
      }, [_c('div', {
        staticClass: "mdl-card__title mdl-card--expand"
      }), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__actions"
      }, [_c('span', {
        staticClass: "mdl-card__filename"
      }, [_vm._v("\n                  " + _vm._s('Imagen #' + (k + 1) + ' de la incidencia.') + "\n                ")])]), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__menu",
        staticStyle: {
          "left": "16px"
        }
      }, [_c('button', {
        staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
        attrs: {
          "data-i": i,
          "data-k": k
        },
        on: {
          "click": _vm.downloadPicture
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("file_download")])])]), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__menu"
      }, [_c('button', {
        staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
        attrs: {
          "data-i": i,
          "data-k": k
        },
        on: {
          "click": _vm.removePicture
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("delete")])])])])
    })), _vm._v(" "), _c('div', {
      staticClass: "mdl-cell mdl-cell--12-col mdl-typography--text-center"
    }, [_c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.uploadPhoto
      }
    }, [_vm._v("\n              Agregar Fotografía(s)\n              "), _c('input', {
      staticClass: "hidden",
      attrs: {
        "type": "file",
        "accept": "image/*",
        "data-i": i
      },
      on: {
        "change": _vm.showPicture
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
      attrs: {
        "type": "button",
        "data-i": i
      },
      on: {
        "click": _vm.showOldPictures
      }
    }, [_vm._v("\n              Ver imágenes anteriores\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + incidencia.avatar + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "supporting-text"
    }, [_c('strong', [_vm._v("Auditor")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(incidencia.observaciones))])])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + incidencia.aprobacion.avatar + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "supporting-text"
    }, [_c('strong', [_vm._v("Jefe de Auditor")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(incidencia.aprobacion.observaciones))])])]), _vm._v(" "), _c('div', {
      staticClass: "comments mdl-cell mdl-cell--12-col"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.$user.data.avatar || './img/profile-64.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (incidencia.update.observaciones),
        expression: "incidencia.update.observaciones"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "rows": "3"
      },
      domProps: {
        "value": (incidencia.update.observaciones)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          incidencia.update.observaciones = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label"
    }, [_vm._v("Escribe tus observaciones aquí...")])])])])])
  })), _vm._v(" "), _c('footer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.incidencias.length > 0),
      expression: "incidencias.length > 0"
    }],
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "card-footer mdl-card mdl-shadow--2dp"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumen),
      expression: "resumen"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.resumen)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resumen = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label"
  }, [_vm._v("Escribe el resumen de la auditoría aquí...")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("\n              Puedes agregar hasta 3 imágenes como evidencia fotográfica"), _c('br'), _vm._v("\n              para justificar tu calificación.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h4', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Resumen de Auditoria")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-754ecca8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles/Auditor/Newsfeed/Report.vue
// module id = 239
// module chunks = 0